import {
  EFFECTIVE_CONNECTIVITY,
  getEffectiveConnectivity,
  subscribeEffectiveConnectivity,
} from '../network/effectiveConnectivity';
import { setRealtimeSuppressed } from '../network/connectivityPause';
import { runRealtimeResumeHandlers } from './resumeRegistry';
import { runRealtimeTeardownHandlers } from './teardownRegistry';

const REALTIME_RESUME_DEBOUNCE_MS = 1500;

let started = false;
let unsubscribe = null;
let lastConnectivity = getEffectiveConnectivity();
let resumeTimer = null;

function clearResumeTimer() {
  if (resumeTimer != null) {
    clearTimeout(resumeTimer);
    resumeTimer = null;
  }
}

function scheduleRealtimeResume() {
  clearResumeTimer();
  resumeTimer = setTimeout(() => {
    resumeTimer = null;
    if (getEffectiveConnectivity() !== EFFECTIVE_CONNECTIVITY.REACHABLE) return;
    runRealtimeResumeHandlers();
  }, REALTIME_RESUME_DEBOUNCE_MS);
}

function syncRealtimeToConnectivity() {
  const next = getEffectiveConnectivity();
  const wasUnreachable = lastConnectivity === EFFECTIVE_CONNECTIVITY.UNREACHABLE;
  const nowUnreachable = next === EFFECTIVE_CONNECTIVITY.UNREACHABLE;
  const nowReachable = next === EFFECTIVE_CONNECTIVITY.REACHABLE;

  if (!wasUnreachable && nowUnreachable) {
    clearResumeTimer();
    setRealtimeSuppressed(true);
    runRealtimeTeardownHandlers();
  } else if (wasUnreachable && nowReachable) {
    setRealtimeSuppressed(false);
    scheduleRealtimeResume();
  } else if (nowUnreachable) {
    setRealtimeSuppressed(true);
  } else if (nowReachable) {
    setRealtimeSuppressed(false);
  }

  lastConnectivity = next;
}

/** Pause realtime while unreachable; debounced resume when reachable again. */
export function initConnectivityRealtimeGate() {
  if (started || typeof window === 'undefined') return;
  started = true;

  unsubscribe = subscribeEffectiveConnectivity(syncRealtimeToConnectivity);
  syncRealtimeToConnectivity();
}

export function stopConnectivityRealtimeGate() {
  clearResumeTimer();
  unsubscribe?.();
  unsubscribe = null;
  started = false;
  lastConnectivity = getEffectiveConnectivity();
}
